import {HttpError} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {Api} from '../../../../../api'
import type {SignalDetail} from '../../../types/signal'

export const QueryKey = 'signal-detail'

export const useGetSignalDetail = (
  signalId: string,
  options?: UseQueryOptions<SignalDetail, AxiosError<HttpError>>
) => {
  return useQuery<SignalDetail, AxiosError<HttpError>>({
    queryKey: [QueryKey, signalId],
    queryFn: async () => {
      const path = `/upm/signal/${signalId}`
      return (await Api.axiosInstance.get<SignalDetail>(path)).data
    },

    ...options
  })
}
